<template>
  <div>
    <div class="maskPanel" v-if="showTip||showPanel||showFinish||showDownGlb || showDeposit"></div>
    <div class="UploadTip" v-if="showTip">
      <div class="tip_title">Upload 3D Model & Earn Points</div>
      <div class="tip_content">
        <div>
          <div><img src="../assets/svg/girl.svg"/></div>
          <div>Upload Requirements</div>
          <div>1.file size &lt; 100M</div>
          <div>2.file fomat support .glb</div>
          <div>3.file data should be binary</div>
        </div>
        <div>
          <div><img src="../assets/svg/girl2.svg"/></div>
          <div>Points</div>
          <div>Earn 50 points per model.</div>
          <div>Unlock rewards.</div>
        </div>
      </div>
      <div class="tip_btn" @click="nextUpload">Upload 3D Model</div>
      <div class="tip_footer">Accepted models grow our dataset for research and business.</div>
      <img class="closeMask" @click="closeMask" src="../assets/svg/icon_close.svg"/>
    </div>

    <div class="upload_panel" v-if="showPanel">
      <div class="panel_title">Upload 3D Model to Earn Tokens</div>
      <div class="panel_content">
        <div>
          <div v-if="showProcess" class="process">
            <div :style="'width:' + processNum"></div>
          </div>
          <GltfView v-if="showGlbView" :address="address" :uploadFinish="modelUploadCallback" ref="gltfView"/>
        </div>
        <div class="glbView">
          <div @click="SelectFile">Reselect</div>
        </div>
        <div v-if="showError">Upload failed....Please try again</div>

      </div>
      <div class="done_btn">
        <div v-if="isClick" class="canClickBtn" @click="uploadDown">Upload</div>
        <div v-if="!isClick" class="unClickBtn">Upload</div>
      </div>
      <img class="closeMask" @click="closeMask" src="../assets/svg/icon_close.svg"/>
    </div>

    <div class="upload_finish" v-if="showFinish">
      <div class="finish_title">Upload 3D Model to Earn Tokens</div>
      <div class="finish_content">
        <div><img src="../assets/svg/Group.svg"/></div>
        <div>50 <span class="litterFont">WorldKey Token</span></div>
      </div>
      <div class="finish_btn">
        <div @click="closeMask">Done</div>
        <!-- <div @click="reUpload">Upload 3D Model </div> -->
      </div>
      <img class="closeMask" @click="closeMask" src="../assets/svg/icon_close.svg"/>
    </div>

    <div class="upload_finish" v-if="showDownGlb">
      <div class="finish_title">Download Models</div>
      <div class="downglb_content">
        <div><img src="../assets/svg/Group.svg"/></div>
        <div>-100<span class="litterFont">WorldKey Token</span></div>
      </div>
      <div class="downglb_tip">Download file with cost 100 token, file format will be .glb</div>
      <div class="finish_btn">
        <div @click="downGlbFn">Download</div>
      </div>
      <img class="closeMask" @click="closeMask" src="../assets/svg/icon_close.svg"/>
    </div>

    <div class="deposit" v-if="showDeposit">
      <img class="depositCloseMask" @click="closeMask" src="../assets/svg/icon_close.svg"/>
      <div class="depositActive" v-if="depositConfig&&showDepositContent">
        <div>
          <div><span>{{ depositConfig[0]["percent"] }}%</span><span>More</span></div>
          <div><img src="../assets/jcoin01.png"/></div>
          <div>{{ depositConfig[0]["real_score"] }}</div>
          <div>{{ depositConfig[0]["original_score"] }}</div>
          <div @click="toDeposit(2)"><img src="../assets/matic_coin.png"/> {{ depositConfig[0]["matic_number"] }}MATIC
          </div>
        </div>
        <div>
          <div><span>{{ depositConfig[1]["percent"] }}%</span><span>More</span></div>
          <div><img src="../assets/jcoin02.png"/></div>
          <div>{{ depositConfig[1]["real_score"] }}</div>
          <div>{{ depositConfig[1]["original_score"] }}</div>
          <div @click="toDeposit(10)"><img src="../assets/matic_coin.png"/> {{ depositConfig[1]["matic_number"] }}MATIC
          </div>
        </div>
        <div>
          <div><span>{{ depositConfig[2]["percent"] }}%</span><span>More</span></div>
          <div><img src="../assets/jcoin03.png"/></div>
          <div>{{ depositConfig[2]["real_score"] }}</div>
          <div>{{ depositConfig[2]["original_score"] }}</div>
          <div @click="toDeposit(30)"><img src="../assets/matic_coin.png"/> {{ depositConfig[2]["matic_number"] }}MATIC
          </div>
        </div>
      </div>
      <div class="depositContent" v-if="!showDepositContent">
        <div class="depositTitle">Amount</div>
        <div><img src="../assets/matic_coin.png"/>{{ currNum }} MATIC</div>
        <div class="depositTitle">Network</div>
        <div>Polygon</div>
        <div class="depositTitle">Deposit Address</div>
        <div>
          <div id="qrcode"></div>
        </div>
        <div class="depositTitle">Address</div>
        <div>{{ contract_address }}</div>
      </div>
    </div>
    <input class="fileInput" type="file" ref="file" @change="FileChange" accept=".glb"/>
  </div>
</template>

<script>
import * as api from '../service/getData'
import GltfView from '../components/GltfView'
import web3 from '../utils/index'
import md5 from 'js-md5'
import sha1 from 'sha1'
import QRCode from 'qrcodejs2'
import Pusher from 'pusher-js'
import Cookies from 'js-cookie'
import {getNewUploadFile, getUploadFile} from '../service/getData'

export default {
  name: 'UploadGlb',
  data () {
    return {
      showTip: false,
      showPanel: false,
      showFinish: false,
      uploadPercent: 0,
      showProcess: false,
      processNum: '0',
      showGlbView: false,
      showError: false,
      modelUrl: '',
      isClick: false,
      address: null,
      showDownGlb: false,
      donwGlbUrl: '',
      ngToken: null,
      depositConfig: null,
      currNum: 2,
      showDeposit: false,
      showDepositContent: true,
      contract_address: '',
      pusherObj: null,
      modelDom: null
    }
  },
  created () {
  },
  mounted () {
    this.getDepositConfig()
  },
  methods: {
    initPusher () {
      Pusher.logToConsole = true
      var pusher = this.pusherObj = new Pusher('f89664d2296222e329f7', {
        cluster: 'ap1'
      })
      console.log(this.address)
      var channel = pusher.subscribe(this.address.toLowerCase() + '-channel')
      console.log(channel)
      channel.bind('deposit', (data) => {
        console.log(data)
        this.$prompt.success(data.message)
      })
    },
    closeMask () {
      this.showTip = false
      this.showPanel = false
      this.showFinish = false
      this.showDownGlb = false
      this.showDeposit = false
      this.showDepositContent = true
    },
    toDeposit (num) {
      this.currNum = num
      this.showDepositContent = false
      setTimeout(() => {
        new QRCode('qrcode', {
          width: 150,
          height: 150,
          text: this.contract_address
        })
      }, 1)
    },
    clearInput () {
      this.modelUrl = ''
      this.isClick = false
    },
    SelectFile () {
      this.$refs.file.click()
    },
    async showUpload () {
      this.showTip = true
    },
    async getDepositConfig () {
      let data = await api.getDepositConfig()
      if (data) {
        this.depositConfig = data.deposit_info
        this.contract_address = data.contract_address
      }
    },

    async showDownGlbFn (glburl) {
      this.donwGlbUrl = glburl
      this.address = await web3.connectWeb3()
      Cookies.set('address', this.address, {expires: 7, path: ''})
      if (this.address && this.loginFn()) {
        this.showDownGlb = true
      }
    },
    async downGlbFn () {
      let data = await api.getDownGlb({address: this.address})
      if (data) {
        console.log(data)
        window.location.href = this.donwGlbUrl
      } else {
        if (data.message === 'Insufficient token') {
          this.$prompt.error(data.message)
          this.showDownGlb = false
          this.showDeposit = true
          if (!this.pusherObj) {
            this.initPusher()
          }
        } else {
          this.$prompt.error(data.message)
        }
      }
    },

    async loginFn () {
      if (this.ngToken !== null) return true
      let time = new Date().getTime()
      let sign = sha1(md5(this.address + 'lian1xia.com123' + time))
      let data = await api.getCreateToken({address: this.address, signature: sign, timestamp: time})
      if (data) {
        this.ngToken = data
        // Cookies.set('ngToken', this.ngToken, { expires: 7, path: '' });
        return true
      } else {
        this.$prompt.error(data.message)
      }
    },
    async nextUpload () {
      this.address = await web3.connectWeb3()
      Cookies.set('address', this.address, {expires: 7, path: ''})
      if (this.address && this.loginFn()) {
        this.showTip = false
        this.showPanel = true
        this.SelectFile()
      }
    },
    reUpload () {
      this.showFinish = false
      this.showPanel = true
    },
    async uploadDown () {
      await this.newUpload()
      this.showPanel = false
      this.showFinish = true
      this.showGlbView = false
    },
    async getCoin () {
      this.address = await web3.connectWeb3()
      Cookies.set('address', this.address, {expires: 7, path: ''})
      if (this.address && this.loginFn()) {
        var data = await api.getAddModel({address: this.address, file_url: this.modelUrl})
        console.log(this.modelUrl)
        if (data.status === 200 && data.message === 'OK') {
          var data = await api.getWithdraw({address: this.address})
          if (data.status === 200 && data.message === 'OK') {
            this.clearInput()
            this.showFinish = false
            this.$prompt.success('Claim bonus success')
            this.closeMask()
            this.showUpload()
          } else {
            this.$prompt.error(data.message)
          }
        } else {
          this.$prompt.error(data.message)
        }
      }
    },
    modelUploadCallback (modelDom) {
      this.isClick = true
      this.modelDom = modelDom
      // this.newUpload()
    },
    async FileChange (event) {
      let file1 = this.$refs.file.files[0]
      this.showGlbView = true
      setTimeout(() => {
        this.$refs.gltfView.createFileObjects(file1)
      }, 0)
    },
    async newUpload () {
      if (!this.address) {
        this.$prompt.error('Need to connect wallet')
        return
      }
      if (!this.modelDom) {
        this.$prompt.error('File loading failed')
        return
      }
      const formData = new FormData()
      let file = this.$refs.file.files[0]
      const fileSize = file.size
      const fileSizeMB = fileSize / (1024 * 1024)
      if (fileSizeMB > 100) {
        this.$prompt.error('file size < 100M')
        this.$refs.file.value = null
        return false
      }
      this.processNum = '0%'
      this.showProcess = true
      this.showGlbView = false
      this.showError = false
      formData.append('user_address', this.address)
      formData.append('file', file)
      formData.append('image', this.modelDom)
      var data = await api.getNewUploadFile(formData, (progressEvent) => {
        this.uploadPercent = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        this.processNum = this.uploadPercent + '%'
        console.log(this.uploadPercent)
      })
      console.log(data)
      return
      if (data.url || data.data.url) {
        this.showGlbView = true
        setTimeout(() => {
          const url = data.url || data.data.url
          this.modelUrl = url
          this.showProcess = false
          // this.$refs.gltfView.createObjects(url);
        }, 0)
      } else {
        this.showProcess = false
        this.showError = true
      }
      event.target.value = ''
      this.$refs.file.value = null
      // this.$refs.file.files = []
    }

  },
  components: {
    GltfView
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.closeMask {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 40px;
  right: 32px;
  cursor: pointer;
}

.depositCloseMask {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
}

.fileInput {
  display: none;
}

.process {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 271px;
  height: 6px;
  border-radius: 5px;
  background: var(--neutral-200, #E4E8E8);

  > div {
    border-radius: 5px;
    background: var(--success-500, #24F993);
    height: 100%;
  }
}

.UploadTip {
  width: 150px;
  height: 115px;
  position: fixed;
  z-index: 100;
  background: #fff;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  width: 680px;
  height: auto;
  padding: 44px 0px;
  flex-direction: column;
  align-items: center;
  border-radius: var(--Corner01, 10px);

  gap: 44px;
}

.tip_footer {
  color: var(--neutral-900, #101313);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
}

.tip_title {
  color: var(--neutral-900, #101313);
  text-align: center;
  /* P1/Semi Bold */
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px; /* 122.222% */
}

.tip_content {
  display: flex;
  padding: var(--Corner01, 10px) 100px;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;

  > div {
    > div:nth-child(2) {
      color: var(--neutral-900, #101313);
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 19px;
    }

    > div:nth-child(3), > div:nth-child(4), > div:nth-child(5) {
      color: var(--neutral-900, #101313);
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 17px;
    }
  }

  > div:nth-child(1) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--Corner01, 10px);
  }

  > div:nth-child(2) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--Corner01, 10px);
  }
}

.tip_btn {
  display: flex;
  width: 220px;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  color: var(--neutral-900, #101313);
  border-radius: 10px;
  background: var(--button-linear-default, linear-gradient(90deg, #0FF 25.99%, #6DFBB7 100%));
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  cursor: pointer;
}

.tip_btn:hover {
  background: var(--button-linear-hover, linear-gradient(90deg, #80FFFF 25.99%, #24F993 100%));
}

.upload_panel {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  width: 790px;
  padding: 44px 0px;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  //height:567px;
  border-radius: var(--Corner01, 10px);
  background: var(--shade-0, #FFF);
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.10);
  z-index: 100;
  border-radius: var(--Corner01, 10px);

  .panel_title {
    color: var(--neutral-900, #101313);
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 122.222% */
    position: relative;

    > img {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
    }
  }

  .panel_content {
    width: 100%;
    position: relative;

    > div:nth-child(1) {
      margin: 10px 32px;
      background: var(--neutral-100, #F6F7F7);
      height: 318px;
      position: relative;
    }

    > div:nth-child(2) {
      > div {
        margin: 12px auto;
        border-radius: 8px;
        height: 51px;
        width: 102px;
        line-height: 51px;
        background: var(--button-linear-default, linear-gradient(90deg, #0FF 25.99%, #6DFBB7 100%));
        text-align: center;
        color: var(--neutral-900, #101313);
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        cursor: pointer;
      }

      > div:hover {
        background: var(--button-linear-hover, linear-gradient(90deg, #80FFFF 25.99%, #24F993 100%));
      }
    }

    > div:nth-child(3) {
      color: var(--error-500, #F42935);
      text-align: center;
      /* Caption/Regular */
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 14px;
    }
  }

  .canClickBtn:hover {
    background: var(--button-linear-hover, linear-gradient(90deg, #80FFFF 25.99%, #24F993 100%));
  }

  .canClickBtn {
    color: var(--neutral-900, #101313);
    background: var(--button-linear-default, linear-gradient(90deg, #0FF 25.99%, #6DFBB7 100%));
  }

  .unClickBtn {
    color: var(--neutral-500, var(--neutral-500, #94A4A4));
    background: var(--neutral-200, #E4E8E8);
  }

  .done_btn {
    > div {
      width: 220px;
      height: 54px;
      text-align: center;
      line-height: 54px;
      border-radius: 10px;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      cursor: pointer;
    }
  }
}

.upload_finish {
  display: flex;
  width: 790px;
  padding: 44px 0px;
  flex-direction: column;
  align-items: center;
  gap: 44px;
  position: fixed;
  border-radius: var(--Corner01, 10px);
  z-index: 100;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: var(--Corner01, 10px);
  background: var(--shade-0, #FFF);

  /* Shadow01 */
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.10);

  .finish_title {
    color: var(--neutral-900, #101313);
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 122.222% */
  }

  .finish_content {
    > div:nth-child(1) {
      width: 190px;
      height: 190px;
      border-radius: var(--Name-color, 50px);
      background: linear-gradient(180deg, #D9D9D9 0%, rgba(217, 217, 217, 0.00) 100%);
      position: relative;
      margin: auto;

      img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    > div:nth-child(2) {
      color: #000;
      text-align: center;
      font-size: 48px;
      font-style: normal;
      font-weight: 700;
      line-height: 58px; /* 120.833% */
      letter-spacing: -0.96px;
    }
  }

  .downglb_tip {
    color: var(--Shade-100, #030504);
    text-align: center;

    /* Caption/Regular */
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px; /* 116.667% */
  }

  .downglb_content {
    > div:nth-child(1) {
      width: 190px;
      height: 190px;
      border-radius: var(--Name-color, 50px);
      border-radius: var(--Name-color, 50px);
      background: linear-gradient(180deg, #F87078 0%, rgba(255, 255, 255, 0.00) 100%);
      margin: auto;
      position: relative;

      img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    > div:nth-child(2) {
      color: #000;
      text-align: center;
      font-size: 48px;
      font-style: normal;
      font-weight: 700;
      line-height: 58px; /* 120.833% */
      letter-spacing: -0.96px;
      margin-top: 12px;
    }
  }

  .finish_btn {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 30px;

    > div {
      border-radius: 10px;
      background: var(--button-linear-default, linear-gradient(90deg, #0FF 25.99%, #6DFBB7 100%));
      display: flex;
      width: 220px;
      padding: 16px;
      justify-content: center;
      align-items: center;
      gap: 12px;
      color: var(--neutral-900, #101313);
      /* P1/Semi Bold */
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 22px;
      cursor: pointer;
    }

    > div:hover {
      background: var(--button-linear-hover, linear-gradient(90deg, #80FFFF 25.99%, #24F993 100%));
    }
  }
}

.maskPanel {
  top: 0;
  left: 0;
  position: fixed;
  z-index: 99;
  opacity: 0.7;
  background: var(--neutral-900, #101313);
  width: 100%;
  height: 100%;
}

.deposit {
  width: 900px;
  height: 540px;
  background: url("../assets/SuperMarket_bg.png");
  background-size: 100% 100%;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;

  .depositActive {
    display: flex;
    justify-content: center;

    > div {
      width: 242px;
      height: 479px;
      background: url("../assets/deposit_bg.png");
      background-size: 100% 100%;
      margin-right: 15px;
      margin-top: 35px;
      position: relative;

      > div:nth-child(1) {
        width: 100px;
        height: 100px;
        position: absolute;
        left: -20px;
        top: -20px;

        > span {
          display: block;
          text-align: center;
        }

        > span:nth-child(1) {
          font-size: 20px;
          font-weight: bold;
          margin-top: 30px;
        }

        > span:nth-child(2) {
          font-weight: bold;
        }
      }

      > div:nth-child(2) {
        margin-top: 100px;
        text-align: center;

        > img {
          width: 200px;
        }
      }

      > div:nth-child(3) {
        font-size: 30px;
        color: #FF6C3E;
        text-align: center;
        font-family: "EncodeSans-Bold";
        font-weight: blod;
      }

      > div:nth-child(4) {
        text-align: center;
        color: #375153;
        font-size: 18px;
      }

      > div:nth-child(5) {
        background: var(--button-linear-default, linear-gradient(90deg, #0FF 25.99%, #6DFBB7 100%));
        border-radius: 20px;
        width: 140px;
        height: 40px;
        margin: 20px auto;
        cursor: pointer;

        img {
          height: 30px;
          margin: 5px 5px 5px 5px;
          vertical-align: -14px;
        }

        color: #000;
        font-size: 16px;
        font-family: "EncodeSans-Bold";
        font-weight: blod;
      }
    }

    > div:nth-child(1) {
      > div:nth-child(1) {
        background: url("../assets/20more.png");
        background-size: 100% 100%;
      }
    }

    > div:nth-child(2) {
      > div:nth-child(1) {
        background: url("../assets/50more.png");
        background-size: 100% 100%;
      }

    }

    > div:nth-child(3) {
      > div:nth-child(1) {
        background: url("../assets/100more.png");
        background-size: 100% 100%;
      }
    }
  }

  .depositContent {
    width: 450px;
    margin: 30px auto;
    color: #000;

    .depositTitle {
      font-size: 16px;
      font-family: "EncodeSans-Bold";
      font-weight: blod;
      margin-bottom: 5px;
    }

    > div:nth-child(2) {
      background: #e3e3e3;
      border-radius: 5px;
      padding: 5px;
      font-size: 14px;
      font-family: "EncodeSans-Bold";
      margin-bottom: 20px;

      img {
        width: 30px;
        vertical-align: -8px;
        margin-right: 5px;
      }
    }

    > div:nth-child(4) {
      background: #e3e3e3;
      height: 40px;
      border-radius: 5px;
      line-height: 40px;
      padding-left: 5px;
      font-size: 14px;
      font-family: "EncodeSans-Bold";
      margin-bottom: 20px;
    }

    > div:nth-child(6) {
      width: 150px;
      height: 150px;
      background: #fff;
      padding: 20px;
      margin-bottom: 20px;
    }

    > div:nth-child(8) {
      background: #e3e3e3;
      height: 40px;
      border-radius: 5px;
      line-height: 40px;
      padding-left: 5px;
      font-size: 14px;
      font-family: "EncodeSans-Bold";
    }
  }

}

.litterFont {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/UploadGlb.vue